import React, {ForwardedRef, ReactNode} from 'react';
import classNamesAggregator from "@Containers/functions/classNamesAggregator";

interface ColumnProps {
    className?: string,
    children: ReactNode,
    style?: object,
    reverse?: boolean,
    justify?: boolean,
    center?: boolean,
    wrap?: boolean,
    alignStart?: boolean,
    alignEnd?: boolean,
    scrollRef?: ForwardedRef<HTMLDivElement>,
    onClick?: (any?) => (any),
}

const Column = (props: ColumnProps) => {
    const {
        className = '',
        children,
        style,
        reverse = false,
        justify = false,
        center = false,
        wrap = false,
        alignStart = false,
        alignEnd = false,
        scrollRef,
        onClick,
    } = props

    const activeClasses = classNamesAggregator("gb--column", {
        reverse,
        justify,
        center,
        wrap,
        alignStart,
        alignEnd,
    });

    return (
        <div className={`${activeClasses}${className}`} style={style} ref={scrollRef} onClick={onClick}>
            {children}
        </div>
    )
};

export default Column;